import React, { useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import TopNav from "../../components/navigation/TopNav";
import TimeRangeSelector from "../../components/helpers/TimeRangeSelector";

import StandardScreen, { ScreenContent } from "../../components/layout/StandardScreen";
import Stack from "../../components/layout/Stack";
import Card from "../../components/ui/Card";
import Button from "../../components/ui/Button";
import FormField from "../../components/forms/FormField";
import StatusMessage from "../../components/ui/StatusMessage";
import {
  TableShell,
  Table,
  Th,
  Td,
  NumberTd,
} from "../../components/data/Table";

const narrowShellStyle = {
  width: "100%",
  margin: "0 auto",
};


export default function PayerPurchasesReport() {
  const { t } = useTranslation();

  const [summary, setSummary] = useState([]);
  const [message, setMessage] = useState("");
  const [messageVariant, setMessageVariant] = useState("info");
  const [timeRange, setTimeRange] = useState({ start: "", end: "" });

  const fetchReport = async () => {
    if (!timeRange.start || !timeRange.end) return;

    axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("token")}`;

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/payer/purchases-in-time`,
        {
          params: {
            start: timeRange.start,
            end: timeRange.end,
          },
        }
      );

      setSummary(res.data);

      if (res.data.length === 0) {
        setMessage(t("payer_purchases_report.messages.empty"));
        setMessageVariant("info");
      } else {
        setMessage("");
        setMessageVariant("info");
      }
    } catch (err) {
      console.error("Failed to fetch summary", err);
      setSummary([]);
      setMessage(t("payer_purchases_report.messages.fetch_failed"));
      setMessageVariant("error");
    }
  };

  return (
    <StandardScreen
      topNav={<TopNav title={t("payer_purchases_report.title")} mode="main" />}
    >
      <ScreenContent>
        <div style={narrowShellStyle}>
          <Stack gap="4">

            {/* Filters */}
            <Card title={t("payer_purchases_report.title")}>
              <Stack gap="3">
                <FormField>
                  <div>
                    <TimeRangeSelector onRangeChange={setTimeRange} />
                  </div>
                </FormField>

                <Button onClick={fetchReport} fullWidth>
                  {t("payer_purchases_report.actions.get_report")}
                </Button>

                <StatusMessage variant={messageVariant} message={message} />
              </Stack>
            </Card>

            {/* Table */}
            {summary.length > 0 && (
              <Card>
                <TableShell maxHeight="65vh">
                  <Table>
                    <thead>
                      <tr>
                        <Th columnIndex={0} sticky wrap wider>
                          {t("payer_purchases_report.table.created_at")}
                        </Th>

                        <Th columnIndex={1} wrap wider>
                          {t("payer_purchases_report.table.wallet")}
                        </Th>

                        <Th align="center" wrap wider>
                          {t("payer_purchases_report.table.money")}
                        </Th>
                      </tr>
                    </thead>

                    <tbody>
                      {summary.map((item, index) => (
                        <tr key={`${item.created_at}-${index}`}>
                          <Td columnIndex={0} sticky wrap wider>
                            {new Date(item.created_at)
                              .toLocaleString("en-GB", {
                                year: "numeric",
                                month: "2-digit",
                                day: "2-digit",
                                hour12: false,
                              })
                              .replace(",", "")}
                          </Td>

                          <Td columnIndex={1} wrap wider>
                            {item.to_walletroute}
                          </Td>

                          <NumberTd align="center" wrap wider>{item.delta_money_from_wallet}</NumberTd>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </TableShell>
              </Card>
            )}

          </Stack>
        </div>
      </ScreenContent>
    </StandardScreen>
  );
}